export default __webpack_public_path__ + "assets/webgl/texture1.jpg.pvr.136edddd.ktx";